import React from "react";
import DeviceTypeIcon from "./DeviceTypeIcon";
import {withNamespaces} from "react-i18next";
import ConnectionStatus from "./ConnectionStatus";
import DeviceInfoColumn from "./DeviceInfoColumn";
import DiagnosticModeButton from "./DiagnosticModeButton";
import NetworkDeviceActions from "../layouts/Panel/NetworkDevice/_components/NetworkDeviceActionButtons";
import {connect} from "react-redux";
import {claimTypes} from "../constants/claim.constants";
import SimpleConnectionStatus from "./SimpleConnectionStatus";
import SwitchIgnoreSchedule from "./SwitchIgnoreSchedule";
import IgnoreScheduleModeButton from "./IgnoreScheduleModeButton";

const HilightDeviceBox = ({t, user, item}) => {

    const diagnosticModePermission = user[`c_network-device.actions.diagnostic-mode`] || null;

    let iconsColor = "";
    switch(item.deviceType.label) {
        case "PC":
            iconsColor = 'text-warning';
            break;
        case "LantickPro-4-4":
            iconsColor = 'text-info';
            break;
        case "Dali router":
            iconsColor = 'text-primary';
            break;
        default:
            iconsColor = '';
    }

    let diagnosticModeColor = item.diagnosticMode ? "border border-danger" : "";

    return (
        <div className="col-md-12 col-lg-6 col-xl-4 p-3">
            <div className={"card bg-light mx-sm-1 p-4 " + diagnosticModeColor}>
                <div className="hilight-card">
                    <span className="fa-stack fa-2x ">
                        <i className={"fas fa-circle fa-stack-2x " + iconsColor}> </i>
                        <DeviceTypeIcon customClass="fa-stack-1x fa-inverse" type={item.deviceType.label} />
                    </span>
                </div>

                <div className="text-right"> {
                    item.deviceType.label === "PC" ||
                    item.deviceType.label.toLowerCase().includes('nec') ||
                    item.deviceType.label.toLowerCase().includes('optoma') ||
                    item.deviceType.label.toLowerCase().includes('pjlink') ||
                    item.deviceType.label.toLowerCase().includes('android') ? (
                        <ConnectionStatus status={item.isOnline} networkStatus={item.isOnlineNetwork} />
                    ) : (
                        <SimpleConnectionStatus status={item.isOnlineNetwork} hideDescription={true} />
                    )
                }
                </div>

                <div className="my-2">
                    <span>Type: <b>{item.deviceType.label}</b></span>
                </div>

                <div className="row">
                    <div className="col-md-7">
                        <DeviceInfoColumn networkDevice={item} />
                    </div>
                    <div className="col-md-5 text-right">
                        { diagnosticModePermission === claimTypes.READ_WRITE ? (
                            <React.Fragment>
                                <DiagnosticModeButton size="sm" networkDevice={item} />
                                <IgnoreScheduleModeButton size="sm" networkDevice={item} />
                            </React.Fragment>
                        ) : (<React.Fragment/>) }
                    </div>
                </div>

                <hr/>

                <div className="row">
                    <div className="col-md-12 text-right">
                        <NetworkDeviceActions size="sm" row={item} />
                    </div>
                </div>

            </div>
        </div>
    )
};

const mapStateToProps = (state) => {
    const { user } = state.authenticationReducer;
    return {
        user
    }
};

export default withNamespaces()(connect(mapStateToProps)(HilightDeviceBox));
